import defaultLocale from '../locale/en_US';
var runtimeLocale = Object.assign({}, defaultLocale.Modal);
var localeList = [];

var generateLocale = function generateLocale() {
  return localeList.reduce(function (merged, locale) {
    return Object.assign(Object.assign({}, merged), locale);
  }, defaultLocale.Modal);
};

export function changeConfirmLocale(newLocale) {
  if (newLocale) {
    var cloneLocale = Object.assign({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return function () {
      localeList = localeList.filter(function (locale) {
        return locale !== cloneLocale;
      });
      runtimeLocale = generateLocale();
    };
  }

  runtimeLocale = Object.assign({}, defaultLocale.Modal);
}
export function getConfirmLocale() {
  return runtimeLocale;
}